import {AdServer} from '../../../types/AdServer';
import {mapMarketToAdServer} from '../../../utils/mapMarketToAdServer';

/**
 * The band-axis distribution variant exists per portal — for now only the German
 * market, whose primary ad server is mobile.de (the band boundaries are its EUR
 * price-filter steps). Other markets/portals may get their own band lists later.
 */
export function isPriceBandAxisAvailable(market: string): boolean {
  return market === 'DEU' && mapMarketToAdServer(market)[0] === AdServer.MOBILE_DE;
}
